// extracted by mini-css-extract-plugin
export default {"skipLinks":"SkipLinks_skipLinks__JsAei"};